module.exports = __webpack_public_path__ + "img/customer.1b0f096c.svg";